import React from "react";
import { StyledWaterMarkContainer } from "./common.styles";

const WatermarkComponent = () => {
  return (
    <StyledWaterMarkContainer>
      <img src={require("../../assets/watermark.png")} />
    </StyledWaterMarkContainer>
  );
};

export default WatermarkComponent;
